import MorseBeacon from "../../components/intro/MorseBeacon";

export default function GameRoomPreviewModal({ roomPreview, showMorseInPreview, morse, onClose }) {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/75 px-4">
      <button type="button" className="absolute inset-0 cursor-default" onClick={onClose} aria-label="Fermer" />
      <div className="relative w-full max-w-5xl rounded-2xl overflow-hidden border border-white/10 bg-slate-950 shadow-2xl">
        <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-white/10">
          <div className="min-w-0">
            <p className="text-xs text-slate-400">
              Vue de la salle — <span className="text-slate-200 font-semibold">{roomPreview.pseudo}</span> · <span className="text-slate-300">{roomPreview.role}</span>
            </p>
            <p className="text-sm font-semibold truncate">{roomPreview.label} — Étape {roomPreview.stage}</p>
            {roomPreview.activity && <p className="text-[11px] text-slate-400 truncate">{roomPreview.activity}</p>}
          </div>
          <button type="button" onClick={onClose} className="h-9 w-9 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-slate-200 flex items-center justify-center" title="Fermer (ESC)">✕</button>
        </div>
        <div className="relative bg-black flex justify-center">
          <div className="relative aspect-square h-[78vh] w-auto max-w-full">
            <img src={roomPreview.icon} alt={roomPreview.label} className="absolute inset-0 h-full w-full object-contain" />
            {showMorseInPreview && (
              <MorseBeacon active
                syncStartedAt={morse?.morseStartedAt}
                syncResetCounter={morse?.morseResetCounter || 0}
                serverNow={morse?.serverNow}
                className="left-[42.7%] top-[20.5%] !w-[14.4%] !h-[8.7%]"
              />
            )}
          </div>
        </div>
        <div className="px-4 py-2 border-t border-white/10 text-[11px] text-slate-400">
          Appuyez sur <span className="text-slate-200">ESC</span> ou cliquez en dehors pour fermer.
        </div>
      </div>
    </div>
  );
}